<template>
  <div class="dwp-space-y-8">
    <div class="dwp-flex dwp-justify-between dwp-items-center">
      <ArrowLeftIcon
        @click="$emit('close')"
        class="dwp-text-gray-500 dwp-w-6 dwp-h-6 dwp-cursor-pointer"
      />
      <div
        class="sm:dwp-text-2xl dwp-text-xl dwp-leading-none dwp-text-gray-700 dwp-font-medium"
      >Edit {{ list.title }}</div>
      <div class="dwp-w-6 dwp-h-6"></div>
    </div>

    <div class="dwp-border dwp-border-gray-300 dwp-bg-white dwp-rounded dwp-space-y-5 dwp-pt-8">
      <div class="dwp-px-10 dwp-space-y-2 dwp-text-gray-800">
        <div class="dwp-flex dwp-justify-between dwp-items-start">
          <TeamListText
            :list="list"
            prop="title"
            class="dwp-flex-1 dwp-truncate dwp-text-primary-700"
          />
          <div
            v-if="list.tasks"
            class="dwp-ml-4 dwp-inline-flex dwp-items-center dwp-px-2 dwp-py-1 dwp-rounded-full dwp-text-xs dwp-font-medium dwp-leading-4 dwp-text-primary-700 dwp-bg-primary-100"
          >{{ list.tasks.length }} Tasks</div>
        </div>
        <TeamListContent :list="list" prop="description" />
      </div>

      <div data-cy="team-task-list">
        <Draggable ghost-class="dwp-opacity-0" v-model="list.tasks" handle=".dwp-drag-handle">
          <Task
            v-for="task in list.tasks"
            :key="genUniqueKey(task)"
            :task="task"
            @trash="trash(task)"
            @edit="edit(task, $event)"
            @toggle="toggleDone(task)"
            data-cy="team-task"
            class="dwp-bg-white sm:mx-auto"
          />
        </Draggable>

        <NewTeamTask @add="add" />
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import Task from "@/components/Task.vue";
import { sync } from "vuex-pathify";
import { ArrowLeftIcon, Edit2Icon } from "vue-feather-icons";
import Draggable from "vuedraggable";
import NewTeamTask from "./NewTeamTask.vue";
import TextInput from "@/components/ui/TextInput.vue";
import VButton from "@/components/ui/VButton.vue";

import TeamListText from "./TeamListText.vue";
import TeamListContent from "./TeamListContent.vue";

export default {
  components: {
    Modal,
    Task,
    Draggable,
    TextInput,
    ArrowLeftIcon,
    VButton,
    Edit2Icon,
    TeamListText,
    TeamListContent,
    NewTeamTask,
  },

  props: {
    list: Object,
  },

  watch: {
    list: {
      deep: true,
      handler(val) {
        this.$store.dispatch("team-lists-library/patch", {
          ...val,
        });
      },
    },
  },

  methods: {
    add({ title, notes }) {
      this.list.tasks.push({
        title,
        notes,
      });
    },

    edit(task, { title, notes }) {
      let editIndex = this.list.tasks.indexOf(task);
      this.list.tasks[this.list.tasks.indexOf(task)] = {
        ...task,
        ...{ title, notes },
      };
      this.$forceUpdate();
      this.$store.dispatch("team-lists-library/patch", this.list);
    },

    trash(task) {
      let r = confirm(
        "Are you sure you want to permanently delete this task? There is no undo."
      );
      if (r) {
        this.list.tasks.splice(this.list.tasks.indexOf(task), 1);
      }
    },
  },
};
</script>